import { render, staticRenderFns } from "./VoidSalesReport.vue?vue&type=template&id=25a84c36"
import script from "./VoidSalesReport.vue?vue&type=script&lang=js"
export * from "./VoidSalesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports